<template>
	<section class="-container">
		<p class="-text">
			Thank you for taking the time to help us improve Brand 360. Please select
			from the options below to ensure the fastest response.
		</p>
		<a
			href="https://ease.uwm.com/Lending/Redirect/UwmRedirect?redirectAbsoluteUri=https%3A%2F%2Fask.uwm.com%2Fs%2Fclient-request%3Floanid%3D0000000000%26loanstatus%3DBrand360"
			target="_blank"
		>
			<div class="link-box">
				<div class="circle">
					<font-awesome-icon :icon="['fal', 'question-circle']" />
				</div>
				<div class="f-box">
					<span role="heading" aria-level="2" class="-heading-1"
						>Ask a Question</span
					>
					<p class="-text">
						Do you have a question or need help with Brand 360?
					</p>
				</div>
			</div>
		</a>
		<a
			href="https://ease.uwm.com/Lending/Redirect/UwmRedirect?redirectAbsoluteUri=https%3A%2F%2Fask.uwm.com%2Fs%2Fcreate-idea%3Fparm%3DBrand360"
			target="_blank"
		>
			<div class="link-box">
				<div class="circle">
					<font-awesome-icon :icon="['far', 'lightbulb']" />
				</div>
				<div class="f-box">
					<span role="heading" aria-level="2" class="-heading-1"
						>Suggest an Idea</span
					>
					<p class="-text">
						Do you have an idea to make Brand 360 even better?
					</p>
				</div>
			</div>
		</a>
		<a
			href="https://ease.uwm.com/Lending/Redirect/UwmRedirect?redirectAbsoluteUri=https%3A%2F%2Fask.uwm.com%2Fs%2Fclient-request%3Floanid%3D0000000000%26loanstatus%3DBrand360"
			target="_blank"
		>
			<div class="link-box">
				<div class="circle">
					<font-awesome-icon :icon="['fal', 'bug']" />
				</div>
				<div class="f-box">
					<span role="heading" aria-level="2" class="-heading-1"
						>Report an Issue</span
					>
					<p class="-text">Is Brand 360 not performing as expected?</p>
				</div>
			</div>
		</a>
	</section>
</template>

<script>
export default {
	name: 'feedback',
};
</script>

<style lang="scss" scoped>
.-container {
	padding: 15px;

	.-heading-1 {
		@include typo--roboto__medium;
		font-size: $b360-font-size--large;
		color: $text-base-color;
		font-weight: 500;
		margin-bottom: 5px;
	}
	a {
		text-decoration: none;
	}
	.link-box {
		display: flex;
		border: solid $b360-color--gray__medium 0.5px;
		@include rem('margin-bottom', 15px);
		border-radius: $border-radius;
		padding: 10px;
		background: $white;
		align-items: center;

		.circle {
			height: 2em;
			width: 2em;
			display: flex;
			justify-content: space-around;
			align-items: center;
			background: $brand-blue;
			border-radius: 50%;
			flex-shrink: 0;

			svg {
				color: $white;
			}
		}
	}
	div.f-box {
		display: flex;
		flex-direction: column;
		margin-left: 10px;

		p {
			margin: unset;
			padding: unset;

			@media (max-width: 575px) {
				font-size: 0.95rem;
				white-space: normal;
			}
		}
	}
}
</style>
